export var APP_LOAD_START = 'app/loadStart';
export var APP_LOAD_DONE = 'app/loadDone';
export var APP_LOAD_FAIL = 'app/loadFail';
export var APP_INIT_START = 'app/initStart';
export var APP_INIT_DONE = 'app/initDone';
export var APP_INIT_FAIL = 'app/initFail';
export var APP_SET_LANGUAGE_START = 'app/setLanguageStart';
export var APP_SET_LANGUAGE_DONE = 'app/setLanguageDone';
export var APP_SET_LANGUAGE_FAIL = 'app/setLanguageFail';